import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import InexButton from "../InexButton";

const AddressDeleteConfirmDialog = ({ onClose, ...props }) => {
	return (
		<Dialog onClose={onClose} {...props}>
			<DialogTitle color={"secondary"}>{"Êtes vous sûr(e) de vouloir supprimer cette adresse ?"}</DialogTitle>
			<DialogActions>
				<InexButton
					onClick={onClose}
					variant={"text"}
					textWithGradient={false}
					text={"Annuler"}
					textSx={{
						color: (theme) => theme.palette.secondary.main,
					}}
					sx={{
						width: 100,
						background: "transparent",
						"&:hover": {
							backgroundColor: "grey.300",
						},
					}}
				/>
				<InexButton
					onClick={() => {
						onClose(true);
					}}
					variant={"text"}
					textWithGradient={false}
					text={"Oui"}
					textSx={{
						color: "white",
					}}
					sx={{
						width: 100,
					}}
				/>
			</DialogActions>
		</Dialog>
	);
};

export default AddressDeleteConfirmDialog;
